import utilityBlockApi from '../api/utilityBlockApi';

/**
 * Mở 1 tiện ích (block trong "Tiện ích App") ở tab mới — dùng khi bấm thông báo
 * `/tien-ich/block/:id?ref=…` trên WEB.
 *
 * Trong app thì path này mở màn UtilityWebView; web không có màn đó nên mở tab mới.
 * Link KHÔNG nằm trong thông báo mà tra từ cấu hình tiện ích: thêm tiện ích mới
 * không phải sửa code, và thông báo không thể trỏ người dùng tới host tuỳ ý.
 */
export default async function openUtilityBlockInNewTab(blockId, notiLink, userInfo) {
    // Mở tab TRƯỚC khi await: trình duyệt chặn popup nếu window.open chạy sau async.
    const tab = window.open('about:blank', '_blank');
    if (tab) tab.opener = null;

    try {
        const { blocks } = await utilityBlockApi.fetchUtilityConfig();
        const block = blocks.find((b) => Number(b.id) === Number(blockId));
        if (!block || !/^https?:\/\//i.test(block.link || '')) {
            if (tab) tab.close();
            return;
        }

        const url = new URL(block.link);
        const uid = userInfo?.userId || userInfo?.id;
        if (block.injectUserId && uid) url.searchParams.set('user_id', String(uid));

        // ref: tham chiếu site gửi kèm (vd itemid sản phẩm) để trang cuộn tới đúng mục
        const ref = (notiLink?.match(/[?&]ref=([^&#]+)/) || [])[1];
        if (ref) url.searchParams.set('ref', decodeURIComponent(ref));

        if (tab) tab.location.href = url.toString();
        else window.location.href = url.toString(); // popup bị chặn -> đi thẳng
    } catch {
        if (tab) tab.close();
    }
}
